import { render, staticRenderFns } from "./SectionContentQuote.vue?vue&type=template&id=5fe4a65d&"
import script from "./SectionContentQuote.vue?vue&type=script&lang=js&"
export * from "./SectionContentQuote.vue?vue&type=script&lang=js&"
import style0 from "./SectionContentQuote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports